import { createSlice } from '@reduxjs/toolkit'

export const userReducer = createSlice({
    name: 'user',
    initialState: {
        user: sessionStorage.getItem("loggedUser") ? JSON.parse(sessionStorage.getItem("loggedUser")) : null,
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
            if(!action.payload){
                sessionStorage.removeItem("loggedUser")
            }else{
                sessionStorage.setItem("loggedUser", JSON.stringify(action.payload))
            }
        },
    },
})

export const { setUser } = userReducer.actions

export default userReducer.reducer